import React, { useEffect, useRef, useState } from 'react'
import SingleAnalyticsHeader from '../student/SingleAnalyticsHeader'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../../utils/util'
import DayFilteringWidget from '../student/DayFilteringWidget'
import { daysFilterList } from '../class/ClassAnalyticsWidgets'
import OrganizationCardWidget from './OrganizationCardWidget'
import OrganizationAnalyticsWidgets from './OrganizationAnalyticsWidgets'
import { useDaysUrlFilter } from '../useAnalyticsUrlFilters'

function OrganizationAnalyticsHome() {
    const { t } = useTranslation()
    const { daysFilter, setDaysFilter } = useDaysUrlFilter()
    // Deliberately not URL-backed: this scope is institution/year/class and its
    // items carry an institution_id, which the ?year=/?classId= scheme cannot
    // represent -- serialising through it would quietly reset the filter to all.
    const [selectedOptions, setSelectedOptions] = useState({ all: true, selected: [] })
    const [showFilter, setShowFilter] = useState(false)

    const widgetsRef = useRef(null)
    const scrollRef = useRef(null)

    usePageTitle(`Upstrive Education - Organization Analytics`)

    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                const scrollTop = scrollRef.current.scrollTop
                setShowFilter(scrollTop > 100)
            }
        }

        const widgetsElement = scrollRef.current
        if (widgetsElement) {
            widgetsElement.addEventListener('scroll', handleScroll)

            // Initial check
            handleScroll()
        }

        return () => {
            if (widgetsElement) {
                widgetsElement.removeEventListener('scroll', handleScroll)
            }
        }
    }, [scrollRef.current])

    return (
        <div id="studentAnalyticsId" className="flex flex-col bg-[#F3EFFF] overflow-y-auto h-screen pr-[10px] xl:pr-[40px] pl-[10px] xl:pl-[40px] transition-all pt-[24px]">
            <div className="max-w-[1360px] mx-[auto] w-full ">
                <SingleAnalyticsHeader showSearch={false} showInfo={false} />

                <div className="mt-[10px] flex flex-row items-center justify-between gap-[15px]">
                    <p className="text-darkenPurple transition-all leading-[60px] text-[38px] font-semibold xl:!text-[48px] lg:!text-[40px] truncate">
                        {t('Organization analytics')}
                    </p>
                    <div
                        className="transition-all duration-300 ease-in-out"
                        style={{
                            opacity: showFilter ? 1 : 0,
                            visibility: showFilter ? 'visible' : 'hidden',
                            transform: showFilter ? 'translateY(0)' : 'translateY(-10px)',
                        }}
                    >
                        <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
                    </div>
                </div>

                <div className="w-full border-b border-b-white mt-5"></div>

                <div className="flex flex-row items-stretch xl:gap-6 transition-all " style={{ minHeight: 'max(685px, calc(100vh - 160px))' }}>
                    <div className="pt-[20px] w-auto min-h-full" data-tour="class-card">
                        <OrganizationCardWidget setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} />
                    </div>
                    <div className="flex-1 relative" data-tour="analytics-widgets" id="analytics-widgets">
                        <div className="absolute inset-0 overflow-y-auto" ref={scrollRef}>
                            <OrganizationAnalyticsWidgets selectedOptions={selectedOptions} daysFilter={daysFilter} setDaysFilter={setDaysFilter} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrganizationAnalyticsHome
